import React from "react";
import replace from "lodash/replace";
import trim from "lodash/trim";
import { SourceObject } from "@react-pdf/types";
import { PDFEntitlementIcon } from "../../types/enums";
import { Nullable } from "../../types/common";
import { OpeningDinnerIcon } from "../pdf/pdfDocument/icons/OpeningDinnerIcon";
import { OnsiteAccessIcon } from "../pdf/pdfDocument/icons/OnsiteAccessIcon";
import { EarlyAccessIcon } from "../pdf/pdfDocument/icons/EarlyAccessIcon";
import { CocktailIcon } from "../pdf/pdfDocument/icons/CocktailIcon";
import { ClosingDinnerIcon } from "../pdf/pdfDocument/icons/ClosingDinnerIcon";
import { BuyerClubIcon } from "../pdf/pdfDocument/icons/BuyerClubIcon";
import { CoffeeIcon } from "../pdf/pdfDocument/icons/CoffeeIcon";
import { BronzeIcon } from "../pdf/pdfDocument/icons/BronzeIcon";
import { SilverIcon } from "../pdf/pdfDocument/icons/SilverIcon";
import { GoldIcon } from "../pdf/pdfDocument/icons/GoldIcon";
import { VipIcon } from "../pdf/pdfDocument/icons/VipIcon";
import { SiaMember } from "../pdf/pdfDocument/icons/SiaMember";
import { ConferenceIcon } from "../pdf/pdfDocument/icons/ConferenceIcon";

const validatePdfColor = (color: string | null, fallbackColor: string) => {
  let trimmedColor = trim(color!, " ");

  if (trimmedColor && trimmedColor.startsWith("#")) {
    trimmedColor = replace(trimmedColor, "#", "");
  }

  if (trimmedColor && (trimmedColor.length === 6 || trimmedColor.length === 3)) {
    return trimmedColor;
  }
  return fallbackColor;
};

const returnSrc = (src: string): SourceObject => ({
  uri: src,
  method: "GET"
});

const getIconByName = (iconName: Nullable<PDFEntitlementIcon>): Nullable<React.FC> => {
  if (iconName === PDFEntitlementIcon.VIP) {
    return VipIcon;
  } else if (iconName === PDFEntitlementIcon.GOLD) {
    return GoldIcon;
  } else if (iconName === PDFEntitlementIcon.SILVER) {
    return SilverIcon;
  } else if (iconName === PDFEntitlementIcon.BRONZE) {
    return BronzeIcon;
  } else if (iconName === PDFEntitlementIcon.COFFEE) {
    return CoffeeIcon;
  } else if (iconName === PDFEntitlementIcon.BUYER_CLUB) {
    return BuyerClubIcon;
  } else if (iconName === PDFEntitlementIcon.CLOSING_DINNER) {
    return ClosingDinnerIcon;
  } else if (iconName === PDFEntitlementIcon.COCKTAIL) {
    return CocktailIcon;
  } else if (iconName === PDFEntitlementIcon.EARLY_ACCESS) {
    return EarlyAccessIcon;
  } else if (iconName === PDFEntitlementIcon.ONSITE_ACCESS) {
    return OnsiteAccessIcon;
  } else if (iconName === PDFEntitlementIcon.OPENING_DINNER) {
    return OpeningDinnerIcon;
  } else if (iconName === PDFEntitlementIcon.SIA_MEMBER) {
    return SiaMember;
  } else if (iconName === PDFEntitlementIcon.CONFERENCE) {
    return ConferenceIcon;
  }
  console.warn(`Invalid iconName property provided: ${iconName}`);
  return null;
};

const PDFUtils = {
  validatePdfColor,
  returnSrc,
  getIconByName
};

export default PDFUtils;
